import { FC, useState } from "react";
import { ModalInvoicePreview } from "src/app/layout/chat-handle/components/modals/InvoicePreview";
import { Order } from "src/app/models/Order";

type OrderSNCellProps = {
  orderData: Order;
  isAvailableToProcess: boolean;
};

export const OrderSNCell: FC<OrderSNCellProps> = ({
  orderData,
  isAvailableToProcess,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div
        className={`w-fit d-flex flex-row align-items-center justify-content-center cursor-pointer`}
        onClick={() => orderData?.shippingLabelFile?.url && setShowModal(true)}
      >
        <p
          className={`${isAvailableToProcess ? "fw-bolder" : ""} m-0 p-0`}
          style={{
            color: "#777",
            overflowWrap: "normal",
            // flexGrow: 1,
            // flexShrink: 1,
            // minWidth: 0,
            // wordBreak: "break-word",
            // whiteSpace: "normal",
            // overflowWrap: "break-word",
          }}
        >
          {orderData.ordersn}
        </p>
        {orderData?.shippingLabelFile?.url && (
          <i className="fas fa-eye ms-2"></i>
        )}
      </div>
      {showModal && (
        <ModalInvoicePreview
          open={showModal}
          close={closeModal}
          marketplaceType={orderData.marketplaceType || ""}
          data={orderData}
        />
      )}
    </>
  );
};
